export class UserProfileModel {
  constructor (data) {
    this.userProfileId = data ? data.userProfileId : ""
    this.login = data ? data.login : ""
    this.name = data ? data.name : ''
    this.number = data ? data.number : 0
    this.surname = data ? data.surname : ''
    this.patronymic = data ? data.patronymic : ""
    this.email = data ? data.email : ''
    this.amount = data ? data.amount : 0
    this.availability = data ? data.availability : false
  }

  isAllFieldFilled () {
    return this.name.length > 0 && this.surname.length > 0 && this.email.length > 0
  }

  static clearItems () {
    return {
      userProfileId: "",
      login: "",
      name: "",
      surname: "",
      email: ""
    }
  }

  toCsv (delimiter) {
    const delim = delimiter || ";"
    return (
      this.fio +
      delim +
      this.participantId +
      delim +
      this.birthdayHuman +
      delim +
      this.cardNumber +
      delim +
      this.expiredDate +
      delim +
      this.passcode +
      delim +
      this.phone +
      delim +
      this.genderHuman +
      delim +
      this.childrenHuman + delim + '\n'
    )
  }
}

export const UserModelCampaignsTitlesModel = [
  {
    text: "Имя",
    value: "name",
    filterType: "text",
    filterValues: []
  },
  {
    text: "Фамилия",
    value: "surname",
    filterType: "text",
    filterValues: []
  },
  {
    text: "Телефон",
    value: "login",
    filterType: "text",
    filterValues: []
  },
  {
    text: "Эл. почта",
    value: "email",
    filterType: "text",
    filterValues: []
  },
  {
    text: "Номер карты",
    value: "cardNumber",
    filterType: "text",
    filterValues: []
  },
  {
    text: "Дата окончания обслуживания",
    value: "expiredDate",
    filterType: "text",
    filterValues: []
  },
]
export const UserModelTitlesModel = [
  {
    text: "Имя",
    value: "name",
    filterType: "text",
    filterValues: []
  },
  {
    text: "Фамилия",
    value: "surname",
    filterType: "text",
    filterValues: []
  },
  {
    text: "Телефон",
    value: "login",
    filterType: "text",
    filterValues: []
  },
  {
    text: "Эл. почта",
    value: "email",
    filterType: "text",
    filterValues: []
  },
  {
    text: "Номер карты",
    value: "cardNumber",
    filterType: "text",
    filterValues: []
  },
  {
    text: "Дата окончания обслуживания",
    value: "expiredDate",
    filterType: "text",
    filterValues: []
  },
  {
    text: "Баланс счёта",
    value: "amount",
    filterType: "text",
    filterValues: []
  },
]

export const UserProfileCampaignsHeadersModel = UserModelCampaignsTitlesModel.map(m =>
    Object.fromEntries(
        Object.entries(m)
            .filter(([key]) => ['text', 'value'].includes(key))
    )
)
export const UserProfileHeadersModel = UserModelTitlesModel.map(m =>
    Object.fromEntries(
        Object.entries(m)
            .filter(([key]) => ['text', 'value'].includes(key))
    )
)
